import { UserRoles } from '../../user.enums';

export const checkIfSuperAdmin = (roles: number[]): boolean => (
	roles.includes(UserRoles.superAdmin)
);

export const checkIfLiquidBulkUser = (roles: number[]): boolean => (
	roles.includes(UserRoles.liquidBulk)
);
